import { Scrubber } from 'slate';

const scrubbableKeys = [
  'text',

  // Link
  'link_href',

  // Transcript Speaker
  'speaker_name',

  // Embedded report
  'bookmark_path',

  // Media
  'media_src',
  'media_alt',

  // Embed
  'embed_src',

  // Attachment
  'attachment_fileName',

  // Reference User and Reference aha object
  'reference_url',
  'reference_name',
  'reference_num',

  // Shared Snippet
  'sharedSnippet_token',

  // Email variable
  'variable_name',
];

Scrubber.setScrubber((key, value) => {
  if (scrubbableKeys.includes(key) && typeof value === 'string') {
    return new Array(value.length).fill('*').join('');
  }

  return value;
});
